import { ReactNode } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { EventSearchTabsProvider } from './event-search-tabs-provider';
import { FrEventSearchStateProvider } from './fr-event-search-state-provider';

export function EventSearchProvider({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) {
    const { isFirstResponder } = useApplicationType();

    const content = isFirstResponder ? (
        <FrEventSearchStateProvider>{children}</FrEventSearchStateProvider>
    ) : (
        children
    );

    return <EventSearchTabsProvider initialTab={initialTab}>{content}</EventSearchTabsProvider>;
}
